import styled, { css } from 'styled-components';

export const Description = styled.p`
 ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 140%;
    margin: 0px 0px 24px 0px;
    max-width: 450px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      max-width: 100%;
    }
  `}
`;
